export type LocalMenuItem = {
  name: string;
  path: string;
  icon?: string | null;
  routes?: LocalMenuItem[];
  children?: LocalMenuItem[];
};

export const FIXED_ADMIN_LOGIN = {
  userName: "admin",
  password: "123456",
};

export const FIXED_TENANT_LOGIN = {
  userName: "tenant_admin",
  password: "123456",
};

export const FIXED_ADMIN_USER = {
  id: "admin-001",
  requestId: "admin-001",
  userId: "admin-001",
  userName: FIXED_ADMIN_LOGIN.userName,
  name: "平台管理员",
  nickname: "平台管理员",
  access: "admin",
  roleCode: "PLATFORM_ADMIN",
  headPic:
    "https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png",
  avatar:
    "https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png",
};

export const FIXED_TENANT_USER = {
  id: "tenant-001",
  requestId: "tenant-001",
  userId: "tenant-001",
  tenantId: "tenant-default",
  userName: FIXED_TENANT_LOGIN.userName,
  name: "租户管理员",
  nickname: "租户管理员",
  access: "tenant",
  roleCode: "TENANT_ADMIN",
  headPic:
    "https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png",
  avatar:
    "https://gw.alipayobjects.com/zos/rmsportal/BiazfanxmamNRoxxVxka.png",
};

export const FIXED_ADMIN_MENUS: LocalMenuItem[] = [
  {
    name: "运营中心",
    path: "/operation",
    icon: "AppstoreOutlined",
    routes: [
      {
        name: "项目管理",
        path: "/operation/project-manage",
        icon: "ProjectOutlined",
      },
      {
        name: "通讯录",
        path: "/operation/address-book",
        icon: "ContactsOutlined",
      },
      {
        name: "终端管理",
        path: "/operation/terminal-manage",
        icon: "TabletOutlined",
      },
    ],
  },
  {
    name: "系统管理",
    path: "/system",
    icon: "SettingOutlined",
    routes: [
      {
        name: "系统用户",
        path: "/system/usermanage",
        icon: "TeamOutlined",
      },
      {
        name: "角色管理",
        path: "/system/rolesmanage",
        icon: "SafetyOutlined",
      },
      {
        name: "系统参数",
        path: "/system/params",
        icon: "ControlOutlined",
      },
    ],
  },
];

export const FIXED_TENANT_MENUS: LocalMenuItem[] = [
  {
    name: "首页",
    path: "/tenant/home",
    icon: "HomeOutlined",
  },
  {
    name: "设备监控",
    path: "/tenant/device-monitor",
    icon: "DashboardOutlined",
    routes: [
      {
        name: "终端监控",
        path: "/tenant/device-monitor/terminal-monitor",
        icon: "RadarChartOutlined",
      },
      {
        name: "风险监控",
        path: "/tenant/device-monitor/risk-monitor",
        icon: "AlertOutlined",
      },
      {
        name: "抄表清单",
        path: "/tenant/device-monitor/meter-reading-list",
        icon: "UnorderedListOutlined",
      },
      {
        name: "电能质量",
        path: "/tenant/device-monitor/power-quality",
        icon: "AreaChartOutlined",
      },
      {
        name: "历史数据",
        path: "/tenant/device-monitor/history-data",
        icon: "HistoryOutlined",
      },
    ],
  },
  {
    name: "AI智能化",
    path: "/tenant/ai",
    icon: "RobotOutlined",
    routes: [
      {
        name: "资产健康",
        path: "/tenant/ai/asset-health",
        icon: "HeartOutlined",
      },
      {
        name: "智能诊断",
        path: "/tenant/ai/smart-diagnosis",
        icon: "BugOutlined",
      },
    ],
  },
  {
    name: "能耗统计",
    path: "/tenant/energy-stat",
    icon: "BarChartOutlined",
    routes: [
      {
        name: "历史能耗",
        path: "/tenant/energy-stat/history-energy",
        icon: "LineChartOutlined",
      },
      {
        name: "区域能耗",
        path: "/tenant/energy-stat/area-energy",
        icon: "HeatMapOutlined",
      },
      {
        name: "分项能耗",
        path: "/tenant/energy-stat/item-energy",
        icon: "PieChartOutlined",
      },
    ],
  },
  {
    name: "运维中心",
    path: "/tenant/ops",
    icon: "ToolOutlined",
    routes: [
      {
        name: "终端管理",
        path: "/tenant/ops/terminal-manage",
        icon: "TabletOutlined",
      },
      {
        name: "区域管理",
        path: "/tenant/ops/area-manage",
        icon: "DeploymentUnitOutlined",
      },
      {
        name: "配额阈值设置",
        path: "/tenant/ops/quota-threshold",
        icon: "ControlOutlined",
      },
      {
        name: "告警中心",
        path: "/tenant/ops/alarm-center",
        icon: "BellOutlined",
      },
      {
        name: "工单管理",
        path: "/tenant/ops/work-order",
        icon: "FileTextOutlined",
      },
    ],
  },
  {
    name: "系统管理",
    path: "/tenant/system",
    icon: "SettingOutlined",
    routes: [
      {
        name: "用户管理",
        path: "/tenant/system/user-manage",
        icon: "TeamOutlined",
      },
      {
        name: "角色权限",
        path: "/tenant/system/role-permission",
        icon: "SafetyOutlined",
      },
      {
        name: "操作日志",
        path: "/tenant/system/operation-log",
        icon: "ProfileOutlined",
      },
    ],
  },
];
